
































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass, TbGrade, TbMember } from '@/http';
import { calendarPanel,NumberKeyboard } from "@/components";
import addVipPanel from "./addVipPanel.vue";
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'
import calculate from '@/common/util/calculate';
import { fmoney } from '@/common/money';
import { Toast,Dialog } from 'vant';
dayjs.locale('zh-cn')
@Component({ 
    components: {
        calendarPanel,NumberKeyboard,addVipPanel
    },
})
export default class product extends Vue {
   
    public $refs: {
    };
    @Watch('searchValue.key')
    changSearch(val){
        this.finishPhone(val);
    }

    gradeList = [];

    /**查询项 */
    searchValue={
        key:"",
        gradeid:"",
        start:"",
        end:"",
        name:"",
        consumptionStart:"",
        consumptionEnd:"",
        sortType:5,
        sortValue:2,
        skip:0,
        count:10,
    }
    /**时间类型下拉 */
    showStatusPopover = false;
    timeType = 1;
    timeOptions=[
        {
            label:"注册时间",
            value:1,
        },
        {
            label:"最新消费",
            value:2,
        },
        
    ]

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表展示
     * 1:图
     * 2：表格
     */
    showType=1;

    userInfo:any={};

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    timeActive=null;

    /**新增会员弹窗 */
    addVipShow = false;
    isAdd = true;

   get getTimeStatus(){
    let str = "";
    str = this.timeOptions.find(v=>v.value==this.timeType).label
    return str;
   }

   get gradeCount(){
    let val = 0;
    let arr = this.gradeList.filter(v=>v.memberCount).map(v=>v.memberCount);
    if(arr.length>0){
        val = arr.reduce((a,b)=>calculate.addition(a,b));
    }
    return val;
   }

   fmoney = fmoney;
   /**总余额 */
   balanceTotal = 0;
   /**总积分 */
   socreTotal = 0;
   /**总成交额 */
   priceTotal = 0;

    created() {
        if (this.$route.query.start) {
            this.searchValue.start = this.$route.query.start;
            this.searchValue.end = this.$route.query.end;
            this.startDate = dayjs(this.$route.query.start).format("YYYY-MM-DD");
            this.endDate = dayjs(this.$route.query.end).format("YYYY-MM-DD");
        }else{
            this.searchValue.start = "";
            this.searchValue.end = "";
            this.startDate = "";
            this.endDate = "";
        }
    }

    async activated() {
        if (this.$route.query.start) {
            this.searchValue.start = this.$route.query.start;
            this.searchValue.end = this.$route.query.end;
            this.startDate = dayjs(this.$route.query.start).format("YYYY-MM-DD");
            this.endDate = dayjs(this.$route.query.end).format("YYYY-MM-DD");
        }else{
            this.searchValue.start = "";
            this.searchValue.end = "";
            this.startDate = "";
            this.endDate = "";
        }
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        await this.getGradeList();
        await this.getList();
        await this.getTotal();
        /**连接蓝牙后补充打印 */
        // window['finishBluetooth'] = (val) => {
        //     if(val=='1'){
        //       this.jumpBluetooth(val);
        //     }else if(val=='true'){
        //         if(localStorage.getItem('blueInfo')){
        //             window.webkit.messageHandlers.connectPrinter.postMessage(localStorage.getItem('blueInfo'));
        //             localStorage.removeItem('blueInfo')
        //         }
               
        //     }
        // }
    }
    // jumpBluetooth(val){
    //     window.webkit.messageHandlers.searchForBluetooth.postMessage('searchForBluetooth');
    //     this.$router.push(`/pad/setting/chooseBlue?name=xp&from=reail&needPrint=true`);
    // }
    async mounted(){
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        await this.getGradeList();
        await this.getTotal();
        
    }

    async getGradeList(){
        let res = await TbGrade.GetGradeList();
        let index = res.findIndex(v=>v.name=='普通会员');
        if(index>-1){
            let form = res[index];
            res.splice(index,1);
            res.push(form);
        }
        this.gradeList = res;
    }

    finishPhone(val){
        this.searchValue.key = val;
        this.getList();
        this.getTotal()
    }

    chooseAllGrade(){
        this.searchValue.gradeid = "";
        this.refreshing = true
        // this.getList();
        this.onRefresh();
        this.getTotal()
    }
    chooseGrade(item,index){
        this.searchValue.gradeid = item.id;
        this.getList();
        this.getTotal();
    }
    async getTotal(){
        let res = await TbMember.GetTbMemberList(Object.assign({},this.searchValue,{skip:0,count:-1}));
        let arr1 = res.items.filter(v=>v.balance).map(v=>v.balance);
        if(arr1.length>0){
            this.balanceTotal = arr1.reduce((a,b)=>calculate.addition(a,b));
        }else{
            this.balanceTotal = 0;
        }
        let arr2 = res.items.filter(v=>v.integral).map(v=>v.integral);
        if(arr2.length>0){
            this.socreTotal = arr2.reduce((a,b)=>calculate.addition(a,b));
        }else{
            this.socreTotal = 0;
        }
        let arr3 = res.items.filter(v=>v.totalMoney).map(v=>v.totalMoney);
        if(arr3.length>0){
            this.priceTotal = arr3.reduce((a,b)=>calculate.addition(a,b));
        }else{
            this.priceTotal = 0;
        }
        
    }
   
    openselDate() {
        this.pickerShow = true;
    }
    /**确定选择时间 */
    onselConfirm(date){
        const [start, end] = date;
        this.startDate = dayjs(start).format("YYYY-MM-DD");
        this.endDate = dayjs(end).format("YYYY-MM-DD");
    
        this.pickerShow = false;
        this.timeActive = null;
        this.setTimeSearch();
    }
    closeTime(){
        this.pickerShow = false;
    }
    
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.searchValue.count=10;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbMember.GetTbMemberList(Object.assign({},this.searchValue))
            this.list = this.searchValue.skip==0? res.items.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format('YYYY-MM-DD'),
                    recentConsumptionTime:v.recentConsumptionTime?dayjs(v.recentConsumptionTime).format('YYYY-MM-DD'):"",
                }
            }):this.list.concat(res.items.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format('YYYY-MM-DD'),
                    recentConsumptionTime:v.recentConsumptionTime?dayjs(v.recentConsumptionTime).format('YYYY-MM-DD'):"",
                }
            }));
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            console.log('list',this.list);
            
            }
    }
    /**获取商品列表 */
    async getList(){
        // this.onRefresh();
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=10;
        this.total = 0;
        this.currentPage = 1;

        let res = await TbMember.GetTbMemberList(Object.assign({},this.searchValue))
        this.list = res.items.map(v=>{
            return{
                ...v,
                createTime:dayjs(v.createTime).format('YYYY-MM-DD'),
                recentConsumptionTime:v.recentConsumptionTime?dayjs(v.recentConsumptionTime).format('YYYY-MM-DD'):"",
            }
        });
        this.total  = res.totalCount;

        this.getTotal()

    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            key:"",
            gradeid:"",
            start:"",
            end:"",
            name:"",
            consumptionStart:"",
            consumptionEnd:"",
            sortType:null,
            sortValue:null,
            skip:0,
            count:10,
        }
        this.timeType=1;
        this.timeActive=null;
        this.startDate = "";
        this.endDate = "";
        this.showStatusPopover = false;
        this.getList();
        this.getTotal()
    }
   
    async sortFun(val){
        switch (val) {
            case 1:
                this.searchValue.sortType=1;
                break;
            case 2:
                this.searchValue.sortType=2;
                break;
            case 3:
                this.searchValue.sortType=3;
                break;
            case 4:
                this.searchValue.sortType=4;
                break;
            case 5:
                this.searchValue.sortType=5;
                break;
        
            default:
                break;
        }
        this.searchValue.sortValue = this.searchValue.sortValue==2?1:2;
        await this.getList();
        this.getTotal()
    }
    changeTimeStatusXL(item,index){
        this.timeType = item.value;
        this.showStatusPopover = false;
        this.setTimeSearch();
    }
    async chooseTime(type){
        this.timeActive = type;
        // 获取当前日期
        const today = dayjs();
        const firstDayOfWeek = dayjs().startOf('week');
        const firstDayOfMonth = dayjs().startOf('month');
        const prevMonthStart = today.subtract(1, 'month').startOf('month');  
        const prevMonthEnd = today.subtract(1, 'month').endOf('month')
        switch (type) {
            case 1:
                this.startDate = today.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 2:
                this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 3:
                this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
                this.endDate = today.format("YYYY-MM-DD");
                break;
            case 4:
                this.startDate = prevMonthStart.format("YYYY-MM-DD");
                this.endDate = prevMonthEnd.format("YYYY-MM-DD");
                break;
        
            default:
                break;
        }
        await this.setTimeSearch();
    }
    async setTimeSearch(){
        if(this.timeType==1){
            this.searchValue.start = this.startDate?this.startDate+" 00:00:00":'';
            this.searchValue.end = this.endDate?this.endDate+" 23:59:59":'';
            this.searchValue.consumptionStart="";
            this.searchValue.consumptionEnd="";
        }else{
            this.searchValue.consumptionStart = this.startDate?this.startDate+" 00:00:00":'';
            this.searchValue.consumptionEnd = this.endDate?this.endDate+" 23:59:59":'';
            this.searchValue.start="";
            this.searchValue.end="";
        }
        await this.getList();
        await this.getTotal()
    }

    showAdd(){
        this.isAdd = true;
        this.addVipShow = true;
        this.showStatusPopover = false;

    }
    closeAdd(){
        this.addVipShow = false;
    }
    confirmSaveAdd(){
        this.getGradeList();
        this.getList();
        this.getTotal()
    }
    async editRow(item){
        if(!this.hasAuth('302')){
            Dialog.alert({
                title: '提示',
                message: "暂无操作权限",
                confirmButtonText: '确定',
                confirmButtonColor:'#0491A7'
                }).then(() => {
                
                });
            return;
        }
        this.isAdd = false;
        let res = await TbMember.GetTbMemberById({id:item.id});
        this.addVipShow = true;
        this.$nextTick(()=>{
            this.$refs['addVipPanel'].init(res);
        })
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
    viewDetail(item){
        this.$router.push(`/pad/vip/detail?id=${item.id}`);
    }
    rechargeRow(item){
        this.$router.push(`/pad/vip/recharge?id=${item.id}`);
    }
    
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/components/info.vue